export const DEFAULT = `
{
  "patient":{
    "firstName":"Test",
    "lastName":"Test",
    "dateOfBirth":"2000-01-01T22:00:00.000Z",
    "sex":"MALE",
    "self":true
  },
  "consultation":{
    "date":"2026-01-01T11:00:00.000Z"
  },
  "responses":[
    [
      {
        "questionId":"22",
        "currentPage":"CONSULTATION",
        "currentSection":"CONTEXTE",
        "responses":{
          "22-02": true
        }
      }
    ]
  ]
}
`;

export const DEMODATA = `
{
  "patient":{
    "firstName":"Test",
    "lastName":"Test",
    "dateOfBirth":"1988-07-09T22:00:00.000Z",
    "sex":"MALE",
    "self":true
  },
  "consultation":{
    "date":"2026-08-09T14:00:00.000Z"
  },
  "responses":[
    [
      {
        "questionId":"22",
        "currentPage":"CONSULTATION",
        "currentSection":"CONTEXTE",
        "responses":{
          "22-02": true
        }
      },
      {
        "questionId":"21",
        "currentPage":"CONSULTATION",
        "currentSection":"CONTEXTE",
        "responses":{
          "21-01": true
        }
      },
      {
        "questionId":"222",
        "currentPage":"CONSULTATION",
        "currentSection":"CONTEXTE",
        "responses":{
          "222-02ex01": true
        }
      },
      {
        "questionId":"MedTT01",
        "currentPage":"CONSULTATION",
        "currentSection":"CONTEXTE",
        "responses":{
          "MedTT01-01": "Pouet 1"
        }
      },
      {
        "questionId":"MedTT01",
        "currentPage":"CONSULTATION",
        "currentSection":"CONTEXTE",
        "responses":{
          "MedTT01-02": "Pouet 2"
        }
      },
      {
        "questionId":"LITERACY",
        "currentPage":"CONSULTATION",
        "currentSection":"CONTEXTE",
        "responses":{
          "LITERACY-01": true
        }
      },
      {
        "questionId":"113",
        "currentPage":"CONSULTATION",
        "currentSection":"CONTEXTE",
        "responses":{
          "113-00": true,
          "113-05": false
        }
      }
    ],
    [
      {
        "questionId":"123",
        "currentPage":"COMPLAINTS",
        "currentSection":"MOTIF",
        "responses":{
          "123-01": true
        }
      },
      {
        "questionId":"PB01conf",
        "currentPage":"COMPLAINTS",
        "currentSection":"MOTIF",
        "responses":{
          "PB01conf-01": true
        }
      },
      {
        "questionId":"4",
        "currentPage":"COMPLAINTS",
        "currentSection":"MOTIF",
        "responses":{
          "4-01": true
        }
      },
      {
        "questionId":"57",
        "currentPage":"COMPLAINTS",
        "currentSection":"MOTIF",
        "responses":{
          "57-01": true
        }
      },
      {
        "questionId":"57b",
        "currentPage":"COMPLAINTS",
        "currentSection":"MOTIF",
        "responses":{
          "57b-03": 42
        }
      }
    ]
  ]
}
`;
